import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

export const getEmailQueList = createAsyncThunk("getEmailQueList", async () => {
  try {
    const response = await instance.get("/crm/email-system/email-list");
    return response?.data;
  } catch (error) {
    return error;
  }
});


export const addEmailQueList = createAsyncThunk("addEmailQueList", async (data) => {
  try {
    const response = await instance.post("/crm/email-system/add-email",data);
    return response?.data;
  } catch (error) {
    return error;
  }
});

export const emailSystemSlice = createSlice({
  name: "emailSystemSlice",
  initialState: {
    loading: null,
    error: null,
    response: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getEmailQueList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getEmailQueList.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      state.response = action.payload;
    });
    builder.addCase(getEmailQueList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload?.data;
    })


    builder.addCase(addEmailQueList.pending, (state) => {
      state.loading = true;
    })
    builder.addCase(addEmailQueList.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
    })
    builder.addCase(addEmailQueList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload?.data;
    });
  },
});

export default emailSystemSlice.reducer;
